module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/summary-cost-data/summary-cost-data.component.css
// module id = ./src/app/summary-cost-data/summary-cost-data.component.css
// module chunks = main